(function () {
  const SCROLL_THRESHOLD = 100;
  // Excludes the auth header (id="header"), which has its own behaviour in header-headroom.js.
  const header = document.querySelector('header[data-theme]:not(#header)');
  if (!header) return;

  let ticking = false;

  function updateScrolledState() {
    const scrolled = window.scrollY > SCROLL_THRESHOLD;
    const current = header.getAttribute('data-scrolled') === 'true';
    if (scrolled !== current) {
      header.setAttribute('data-scrolled', scrolled ? 'true' : 'false');
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrolledState);
      ticking = true;
    }
  }

  updateScrolledState();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
